export * from "@workspace/gamja-platform/components/ui/label";
